module.exports = __webpack_public_path__ + "img/wangpengfei.ed4296e6.jpg";